module.exports = __webpack_public_path__ + "img/UTOTTE-2.a74972bb.jpg";